import { render, staticRenderFns } from "./FloorManagement.vue?vue&type=template&id=2bc00c94&scoped=true"
import script from "./FloorManagement.vue?vue&type=script&lang=js"
export * from "./FloorManagement.vue?vue&type=script&lang=js"
import style0 from "./FloorManagement.vue?vue&type=style&index=0&id=2bc00c94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc00c94",
  null
  
)

export default component.exports